import Head from 'next/head';
import React, { useEffect, useRef, useState } from 'react';
import { Tween } from 'react-gsap';
import { Controller, Scene } from 'react-scrollmagic';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import getMetaTagData from '../../src/common/services/getMetaTagData';
function PlayZone({ metaTagData, jWTCheck }) {
  const videoRef = useRef(null);
  const [progessScene, setProgressScene] = useState(0);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    setIsIOS(/iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (progessScene > 0) {
      video.play().catch((err) => {
        console.log('Video play failed:', err);
      });
    } else {
      video.pause();
    }
  }, [progessScene]);

  useEffect(() => {
    // * 최대한 퍼블소스 그대로 사용
    // * 1) JSX컨벤션: class, style 변환
    // * 2) 퍼블UI 코드 되도록 그대로 사용 리엑트 Swipe (X), Vanilla Swipe 사용
    // * 3) 퍼블CSS 내 경로수정 ex) ../image/file.png -> /images/file.png
    // * 4) Tween 처리

    try {
      const swiper = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination],
        loop: true,
        shortSwipes: false,
        loopedSlides: 2,
        infinite: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            var paginationTexts = ['홈피드', '라이브', '플레이픽', '배지'];
            return `<span class="${className}">${paginationTexts[index]}</span>`;
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      return () => {
        if (swiper && swiper.destroy) swiper.destroy();
      };
    } catch (error) {
      console.error('Swiper init error:', error);
    }
  }, []);

  useEffect(() => {
    const videoElement = document.querySelector('video');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (videoElement) {
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  }, []);

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents_sbsplay">
        <div className="sbsplayAboutContents appInfo2024">
          <h2 className="hide">SBS play 앱 소개 페이지</h2>
          <div className="appInfoTop_w">
            <div className="appInfo_inner">
              <span className="bg_app">
                <i className="hide">SBS play 앱</i>
              </span>
              <div className="appInfoText_w">
                <img src="/images/about_sbsplay_logo.png" alt="SBS play" />
                <span className="appInfoText-black">
                  <em className="appInfoText-pink">즐거움</em>을 잇는{' '}
                  <em className="appInfoText-purple">새로움</em>을 입힌
                  <br />
                  SBS play 앱을 만나볼까요?
                </span>
                <div className="appInfoBtn_w">
                  {!isIOS && (
                    <a
                      href="https://play.google.com/store/apps/details?id=kr.co.sbs.videoplayer"
                      target="_blank"
                      className="appBtn-typeBlack"
                    >
                      <span className="iconSvg_googleplay">
                        <i className="ir">구글 플레이에서 다운로드</i>
                      </span>
                      Google Play
                    </a>
                  )}
                  <a
                    href="https://apps.apple.com/us/app/id1020136055"
                    target="_blank"
                    className="appBtn-typeBlack"
                  >
                    <span className="iconSvg_appstore">
                      <i className="ir">애플 스토어에서 다운로드</i>
                    </span>
                    App store
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="appInfoSwiper_w">
            <div className="appInfoText_w">
              <em className="appInfoText-purple">계속되는 즐거움의 스테이지</em>
              <span className="appInfoText-black">
                더 많은 SBS play 서비스는 여기 다{' '}
                <em className="appInfoText-pink">잇다</em>니깐!
              </span>
            </div>
            <div className="appInfoList_w swiper-container">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="appInfoList_inner">
                    <img src="/images/app_homefeed.png" alt="홈피드" />
                    <i className="hide">
                      내가 관심 가질 콘텐츠만 골라서! 무제한 즐기는 피드형
                      콘텐츠 - 프로그램 구족하고 콘텐츠 업로드 소식 받자! -
                      스크롤을 내릴때마다 새로운 콘텐츠를 추천!
                    </i>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="appInfoList_inner">
                    <img src="/images/app_live.png" alt="라이브" />
                    <i className="hide">
                      즐거움을 놓치는 일이 없도록! 라이브예약 알림으로 SBS
                      본.방.사.수
                    </i>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="appInfoList_inner">
                    <img src="/images/app_playpick.png" alt="플레이픽" />
                    <i className="hide">
                      방송예정인 작품들과 무료작을 플레이픽에서 한눈에 보자!
                    </i>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="appInfoList_inner">
                    <img src="/images/app_badge.png" alt="배지" />
                    <i className="hide">
                      간단한 미션만 달성해도 S포인트를?! 배지 모르는 재미에
                      포인트는 덤!
                    </i>
                  </div>
                </div>
              </div>
              <div className="swiper-pagination"></div>
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </div>
          </div>

          <div className="appInfoSubscribe_w">
            <div className="appInfoSubs-top">
              <div className="appInfoText_w">
                <strong className="appInfoText-black">
                  새로워진{' '}
                  <span className="appInfoText-round icon_badge">
                    배지 미션
                  </span>{' '}
                  도{' '}
                  <span className="appInfoText-round icon_live">
                    라이브채널
                  </span>{' '}
                  도
                  <br />
                  끊임없이 즐기는 방법!
                </strong>
              </div>
            </div>
            <div className="appInfoSubs-bottom">
              <div className="appInfoText_w">
                <strong className="appInfoText-black">
                  <em className="appInfoText-purple">정기구독</em>으로{' '}
                  <em className="appInfoText-pink">초고화질 영상을 광고없이</em>
                  <br />
                  자유롭게 시청 가능
                </strong>
              </div>
              <img
                src="/images/bg_subs_cont.png"
                alt="초고화질 라이브(1080p), SBS 다시보기(480p,720p,10080p), 모든 디바이스 사용가능, 광고 SKIP"
              />
              <a
                href="https://www.sbs.co.kr/pass/pass"
                className="appBtn-typePink"
              >
                정기구독하기
                <span className="iconSvg_arrow">
                  <i className="ir"></i>
                </span>
              </a>
            </div>
          </div>

          <Controller>
            <Scene duration="100%" triggerElement="#PC" triggerHook="0.2" pin>
              {(progress) => {
                setProgressScene(progress);

                return (
                  <div className="appInfoBottom_w" id="PC">
                    <div
                      className="scroll-down"
                      style={{ opacity: progress > 0 ? 0 : 1 }}
                    >
                      <span className="iconSvg_arrow"></span>
                    </div>
                    <div className="appInfoVideo_w">
                      <Tween
                        from={{
                          duration: 1,
                          css: {
                            opacity: 1,
                            width: '100%',
                          },
                          ease: 'Power4.easeInOut',
                        }}
                        to={{
                          duration: 1,
                          css: {
                            width: 1200,
                          },
                          ease: 'Power4.easeInOut',
                        }}
                        totalProgress={progress}
                        paused
                      >
                        <div className="appInfoVideo">
                          <video
                            ref={videoRef}
                            autoPlay={'autoplay'}
                            muted
                            controls
                            src="/images/@video.mp4"
                            loop={false}
                          ></video>
                        </div>
                      </Tween>
                    </div>

                    <div className="appInfoText_w">
                      <div className="appInfoText-black">
                        개인화 추천으로 더 똑똑해지고 다양한 재미를 더 해진
                        <br />
                        <span className="icon_play">
                          <i className="ir">SBS play</i>
                        </span>{' '}
                        에서 지금 바로 play!
                      </div>
                      <div className="appInfoBtn_w">
                        {!isIOS && (
                          <a
                            href="https://play.google.com/store/apps/details?id=kr.co.sbs.videoplayer"
                            target="_blank"
                            className="appBtn-typeBlack"
                          >
                            <span className="iconSvg_googleplay">
                              <i className="ir">구글 플레이에서 다운로드</i>
                            </span>
                            Google Play
                          </a>
                        )}
                        <a
                          href="https://apps.apple.com/us/app/id1020136055"
                          target="_blank"
                          className="appBtn-typeBlack"
                        >
                          <span className="iconSvg_appstore">
                            <i className="ir">애플 스토어에서 다운로드</i>
                          </span>
                          App store
                        </a>
                      </div>
                    </div>
                  </div>
                );
              }}
            </Scene>
          </Controller>

          {/* <div
            className="bannerEvent_w"
            style={{ backgroundColor: '#EAEAEA' }}
          ></div> */}

          {/* <div className="bannerSurvey_w">
            <div className="bannerSurvey_inner">
              <p className="bannerSurvey-title">
                SBS play에 대한 소중한 의견을 남겨주세요!
              </p>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeiPK4cfR28WIiKZ5-RAzdZIzcCrnHHsHedJByxrJhdk8ZuSw/viewform"
                target="_blank"
                className="bannerSurvey-link"
              >
                설문 참여하기
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(ctx) {
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, 'event', pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default PlayZone;
